import { render, staticRenderFns } from "./SelectSubjectInput.vue?vue&type=template&id=597060b8&scoped=true"
import script from "./SelectSubjectInput.vue?vue&type=script&lang=ts"
export * from "./SelectSubjectInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectSubjectInput.vue?vue&type=style&index=0&id=597060b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597060b8",
  null
  
)

export default component.exports